import { concat, from, of } from "rxjs";
import { actionModalCloseAll, actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionTutorialSelect } from "../../actionTutorial";
import { IdTutorialStep } from "../../IdTutorialStep";
export var pathSelectBuildingInBuildingMenu = function (action, state$, deps) {
    var openBuildMenu$ = from([actionModalCloseAll(), actionModalOpen(IdModal.BuildingList)]);
    var selectTutorialStep$ = of(actionTutorialSelect(IdTutorialStep.constructWindmill_clickBuildMenu));
    return concat(selectTutorialStep$, openBuildMenu$);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/path/pathSelectBuildingInBuildingMenu.ts
// module id = 2477
// module chunks = 3